export const spinnerSvg = `<svg
                      class="animate-spin"
                      width="10"
                      height="10"
                      viewBox="0 0 10 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M5.625 0.625C5.625 0.25 5.375 0 5 0C4.625 0 4.375 0.25 4.375 0.625V1.875C4.375 2.25 4.625 2.5 5 2.5C5.375 2.5 5.625 2.25 5.625 1.875V0.625Z"
                        fill="#FF5127" />
                      <path
                        d="M5 7.5C4.625 7.5 4.375 7.75 4.375 8.125V9.375C4.375 9.75 4.625 10 5 10C5.375 10 5.625 9.75 5.625 9.375V8.125C5.625 7.75 5.375 7.5 5 7.5Z"
                        fill="#FF5127" />
                      <path
                        d="M3.25 2.375L2.375 1.4375C2.125 1.25 1.6875 1.25 1.4375 1.4375C1.25 1.6875 1.25 2.125 1.4375 2.375L2.3125 3.25C2.5625 3.5 2.9375 3.5 3.1875 3.25C3.5 3 3.5 2.5625 3.25 2.375Z"
                        fill="#FF5127" />
                      <path
                        d="M7.625 8.5625C7.875 8.8125 8.25 8.8125 8.5 8.5625C8.75 8.3125 8.75 7.9375 8.5 7.6875L7.625 6.8125C7.375 6.5625 7 6.5625 6.75 6.8125C6.5 7.0625 6.5 7.4375 6.75 7.6875L7.625 8.5625Z"
                        fill="#FF5127" />
                      <path
                        d="M0 5C0 5.375 0.25 5.625 0.625 5.625H1.875C2.25 5.625 2.5 5.375 2.5 5C2.5 4.625 2.25 4.375 1.875 4.375H0.625C0.25 4.375 0 4.625 0 5Z"
                        fill="#FF5127" />
                      <path
                        d="M10 5C10 4.625 9.75 4.375 9.375 4.375H8.125C7.75 4.375 7.5 4.625 7.5 5C7.5 5.375 7.75 5.625 8.125 5.625H9.375C9.75 5.625 10 5.375 10 5Z"
                        fill="#FF5127" />
                      <path
                        d="M2.375 8.5625L3.25 7.6875C3.5 7.4375 3.5 7.0625 3.25 6.8125C3 6.5625 2.625 6.5625 2.375 6.8125L1.5 7.6875C1.25 7.9375 1.25 8.3125 1.5 8.5625C1.6875 8.75 2.125 8.75 2.375 8.5625Z"
                        fill="#FF5127" />
                      <path
                        d="M7.625 1.4375L6.75 2.3125C6.5 2.5625 6.5 2.9375 6.75 3.1875C7 3.4375 7.375 3.4375 7.625 3.1875L8.5 2.3125C8.75 2.0625 8.75 1.6875 8.5 1.4375C8.3125 1.25 7.875 1.25 7.625 1.4375Z"
                        fill="#FF5127" />
                    </svg>`;
